import clsx from 'clsx';
import * as React from 'react';
import { useState } from 'react';

import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';
import { FormConfirm } from '@/components/Form/FormConfirm';
import {
  FormContactGuessUser,
  iFormContactGuessUserFields,
} from '@/components/Form/FormContactGuessUser';
import { Country } from '@/features/countries';

export type FormContactGuessUserInModalProps = {
  onSubmit: (values: iFormContactGuessUserFields) => void;
  onRequestClose: () => void;
  isOpen: boolean;
  shouldCloseOnOverlayClick?: boolean;
  origin: string;
  countries: Country[];
};

export const FormContactGuessUserInModal = ({
  onSubmit,
  isOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  origin,
  countries,
}: FormContactGuessUserInModalProps) => {
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);

  const onDefaultRequestClose = () => {
    setConfirmIsOpen(false);
    onRequestClose();
  };

  const onDefaultSubmit = (values: iFormContactGuessUserFields) => {
    if (onSubmit) {
      onSubmit(values);

      // TODO: This should be the callback to a successful promise.
      setConfirmIsOpen(true);
    }
  };

  return (
    <PaymentsModal
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onDefaultRequestClose}
    >
      <FormContactGuessUser
        onSubmit={onDefaultSubmit}
        origin={origin}
        className={clsx('py-2 pl-2 pr-5 lg:px-8 lg:pb-8 lg:pt-2 overflow-y-auto max-h-[75vh]', {
          block: !confirmIsOpen,
          hidden: confirmIsOpen,
        })}
        countries={countries}
      />
      <FormConfirm
        className={clsx({
          block: confirmIsOpen,
          hidden: !confirmIsOpen,
        })}
      />
    </PaymentsModal>
  );
};
